import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { registerCamera } from '@/app/services/liveStreaming/liveStreaming';
import { getRooms } from '@/app/services/rooms/rooms';
import * as Actions from '@/app/store/actions';
import {
	Button,
	CircularProgress,
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import './Live.css';
import { useNavigate } from 'react-router-dom';

const CameraRegistration = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [errTxts, setErrTxts] = useState({});
	const [form, setForm] = useState({});
	const [isAdding, setIsAdding] = useState(false);
	const [rooms, setRooms] = useState([]);
	const [roomPage, setRoomPage] = useState(1);

	useEffect(() => {
		let isMounted = true;
		getRooms('', roomPage)
			.then((res) => {
				if (!isMounted) return;
				setRooms((prevRooms) => [...prevRooms, ...res.data.data]);
				const { current_page, last_page } = res.data.meta;
				if (current_page < last_page) {
					setRoomPage((prevPage) => prevPage + 1);
				}
			})
			.catch(() => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get rooms.',
						autoHideDuration: 1500,
						variant: 'error',
					})
				);
			});

		return () => {
			isMounted = false;
		};
	}, [roomPage, dispatch]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setErrTxts({ ...errTxts, [name]: '' });
		setForm({ ...form, [name]: value });
	};

	const handleSubmit = () => {
		setErrTxts({});

		if (!form.camera_id) {
			setErrTxts({ ...errTxts, camera_id: 'This field is required' });
			return;
		}
		if (!form.room_id) {
			setErrTxts({ ...errTxts, room_id: 'This field is required' });
			return;
		}

		if (form) {
			setIsAdding(true);
			registerCamera(form)
				.then((resp) => {
					dispatch(
						Actions.showMessage({
							message: resp.data.message,
							autoHideDuration: 1500,
							variant: 'success',
						})
					);
					setIsAdding(false);
					navigate(-1);
				})
				.catch((err) => {
					if (err.response?.data?.errors) {
						setErrTxts(err.response.data.errors);
						setIsAdding(false);
					} else {
						dispatch(
							Actions.showMessage({
								message: 'Failed to register camera.',
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
						setIsAdding(false);
					}
				})
				.finally(() => setIsAdding(false));
		} else {
			dispatch(
				Actions.showMessage({
					message: 'Failed to register camera.',
					autoHideDuration: 1500,
					variant: 'error',
				})
			);
			setIsAdding(false);
		}
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="add-camera-div mx-auto">
				<div>
					<div className="flex gap-10">
						<Button
							onClick={() => {
								navigate(-1);
							}}
						>
							<img
								alt="Go Back"
								className="cursor-pointer"
								src="assets/images/arrow-long.png"
								style={{ width: '25px' }}
							/>
						</Button>
						<h2 className="font-bold">Camera Registration</h2>
					</div>
					<div className="bg-white rounded form-main-div">
						<div className="form-inner-div">
							<div className="shrink-0 " style={{ marginBottom: '20px' }}>
								<span className="font-bold add-camera-heading">Camera Information</span>
							</div>
							<div className="bg-white rounded mx-auto" style={{ paddingBottom: '70px' }}>
								<div className="grid grid-cols-2" style={{ gap: 40 }}>
									<TextField
										error={!!errTxts.camera_id}
										helperText={errTxts.camera_id}
										label="Camera ID"
										name="camera_id"
										onChange={handleChange}
										style={{ width: '100%' }}
										value={form.camera_id || ''}
										// placeholder='DC:BB:17:9A:CE:86'
									/>
									<FormControl error={!!errTxts.room_id} style={{ width: '100%' }}>
										<InputLabel id="country_code_label">Room Name</InputLabel>
										<Select
											id="room_id"
											labelId="room_id"
											name="room_id"
											onChange={handleChange}
											value={form.room_id || ''}
										>
											{rooms.length ? (
												rooms.map((room) => {
													return (
														<MenuItem key={room.id} value={room.id}>
															<span id={room.id}>{room.name}</span>
														</MenuItem>
													);
												})
											) : (
												<MenuItem>Loading...</MenuItem>
											)}
										</Select>
										{errTxts.room_id ? <FormHelperText>{errTxts.room_id}</FormHelperText> : null}
									</FormControl>
								</div>
							</div>
							<div className="flex justify-center w-max mt-40" style={{ gap: '20px' }}>
								{isAdding ? (
									<div className="flex justify-center">
										<CircularProgress className="mx-auto" />
									</div>
								) : (
									<>
										<CustomButton
											onClick={() => {
												navigate(-1);
											}}
											variant="secondary"
											width={140}
										>
											Cancel
										</CustomButton>

										<CustomButton
											onClick={() => {
												handleSubmit();
											}}
											variant="primary"
											width={140}
										>
											Add
										</CustomButton>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</FuseAnimate>
	);
};

export default CameraRegistration;
